// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6c56f83f","455":"a4a9d92f","977":"ea5a437b"}[chunkId] + ".chunk.js";
};